/**
 * Dev-only diagnostics for errors the app deliberately tolerates (storage unavailable, clipboard blocked, best-effort
 * server sync…). Keeps those code paths observable while developing without surfacing noise to end users; the call
 * compiles to a no-op in production builds.
 */
export function debugWarn(context, error) {
  if (process.env.NODE_ENV === "production") return;
  console.warn(`[tamreer] ${context}`, error);
}
